<template>
  <validation-observer ref="form" slim>
    <div>
      <b-row>
        <b-col cols="6">
          <validation-provider
            name="Contractor Name"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Contractor Name"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.name"
                :disabled="!isNewContractor"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="3">
          <validation-provider
            name="Contract Number"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Contract Number"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.contract_number"
                :disabled="!isNewContractor"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="3">
          <validation-provider
            name="Type"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Type"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.type"
                :disabled="!isNewContractor"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <validation-provider
            name="Nick Name"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Nick Name"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.code"
                :disabled="!isNewContractor"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider
            name="Email"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Email"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.email"
                :disabled="!isNewContractor"
                type="email"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <b-col cols="6">
              <validation-provider
                name="Period Contract"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill mr-4"
              >
                <b-form-group
                  label="Period Contract"
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <b-input-group>
                    <b-form-input
                      :value="formatDate(detail.contract_periode_start)"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                      disabled
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="detail.contract_periode_start"
                        button-only
                        left
                        size="sm"
                        locale="en-US"
                        @context="onContext"
                        :disabled="!isNewContractor"
                        :class="{ 'is-invalid': errors.length }"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <validation-provider
                name="Period Contract"
                rules="required"
                v-slot="{ errors }"
                slim
                class="flex-fill mr-4"
              >
                <b-form-group
                  label=" "
                  label-size="sm"
                  label-class="font-weight-bold"
                  :invalid-feedback="errors[0]"
                >
                  <br />
                  <b-input-group>
                    <b-form-input
                      :value="formatDate(detail.contract_periode_end)"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                      disabled
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="detail.contract_periode_end"
                        button-only
                        left
                        size="sm"
                        locale="en-US"
                        @context="onContext"
                        :disabled="!isNewContractor"
                        :class="{ 'is-invalid': errors.length }"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <validation-provider
            name="Contractor Contact"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Contractor Contact"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.phone"
                :disabled="!isNewContractor"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>

          <validation-provider
            name="Company"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Company"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-input
                autocapitalize="off"
                v-model="detail.company.name"
                :disabled="!isNewContractor"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col>
          <validation-provider
            name="Address"
            rules="required"
            v-slot="{ errors }"
            slim
            class="flex-fill mr-4"
          >
            <b-form-group
              label="Address"
              label-size="sm"
              label-class="font-weight-bold"
              :invalid-feedback="errors[0]"
            >
              <b-form-textarea
                v-model="detail.address"
                rows="4"
                no-resize
                :disabled="!isNewContractor"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </div>
  </validation-observer>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    detail: {
      types: Object,
      default: () => ({
        name: '',
        contract_number: '',
        email: '',
        phone: '',
        address: '',
        company_id: 0,
        is_need_exchange: false,
        is_active: false,
        contract_periode_start: '',
        contract_periode_end: ''
      })
    },
    isNewContractor: {
      types: Boolean,
      default: () => false
    }
  },
  methods: {
    onContext(ctx) {
      // The date formatted in the locale, or the `label-no-date-selected` string
      this.formatted = ctx.selectedFormatted
      // The following will be an empty string until a valid date is entered
      this.selected = ctx.selectedYMD
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>
